import { useRef } from "react";
import { useWebSocket } from "../context/WebSocketContext";
import ChatBody from "./ChatBody";
import ChatFooter from "./ChatFooter";
import ChatHeader from "./ChatHeader";
import { Container, LoaderWrapper, Spinner } from "./styles/ChatStyles";

const ChatContainer = () => {
  const { messages, setMessages, socket, chatEnded } = useWebSocket();
  const exportRef = useRef();

  const isDuplicate = messages.some((m) => m.controlType === "DUPLICATE");

  const isLoading = messages.length === 0 && !isDuplicate;

  const wasDisconnected = messages.some((m) => m.controlType === "DISCONNECT");
  const isSocketOpen = socket?.readyState === WebSocket.OPEN;

  const isDisabled = chatEnded || !isSocketOpen || wasDisconnected || isDuplicate;

  return (
    <Container ref={exportRef}>
      <ChatHeader />

      {isLoading ? (
        <LoaderWrapper>
          <Spinner />
          <p>Conectando...</p>
        </LoaderWrapper>
      ) : isDuplicate ? (
        /* 4. Interface amigável que substitui o chat em caso de erro */
        <LoaderWrapper>
          <div style={{ textAlign: "center", padding: "20px" }}>
            <span style={{ fontSize: "40px" }}>🚫</span>
            <p style={{ color: "#d9534f", fontWeight: "bold", marginTop: "10px" }}>
              Conexão Duplicada
            </p>
            <p style={{ fontSize: "14px", color: "#666" }}>
              Você já possui uma janela de chat ativa. <br />
              Por favor, utilize a sessão que já está aberta.
            </p>
          </div>
        </LoaderWrapper>
      ) : (
        <>
          <ChatBody messages={messages} exportRef={exportRef} />

          {!isDisabled && (
            <ChatFooter
              messages={messages}
              setMessages={setMessages}
              exportRef={exportRef}
            />
          )}
        </>
      )}
    </Container>
  );
};

export default ChatContainer;